module.exports = __webpack_public_path__ + "img/huoban8.d9453331.png";